export default __webpack_public_path__ + "static/media/Trama-LatamChequea3 1.91b76928.png";